export const E_LIBRARY = 'e_library/'
export const E_LIBRARY_ALL = `${E_LIBRARY}all`
export const E_LIBRARY_TYPES = `${E_LIBRARY}types`
